var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfinity = function SvgInfinity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "1 6 22 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.9 9.5c-.38-.7-.74-1.27-1.11-1.74l.3-.3A5.04 5.04 0 0 1 17 6a6 6 0 0 1 0 12c-2.85 0-4.06-1.48-5.91-5.59C9.56 9.01 8.73 8 7 8a4 4 0 0 0 0 8c1.04 0 2.29-.42 3.38-1 .39.66.77 1.2 1.18 1.63A9.62 9.62 0 0 1 7 18 6 6 0 0 1 7 6c2.85 0 4.06 1.48 5.91 5.59C14.44 14.99 15.27 16 17 16a4 4 0 0 0 0-8c-1.25 0-1.82.23-2.53.9l-.57.6Z",
    clipRule: "evenodd"
  })));
};
export default SvgInfinity;